import { EditorContent } from '@tiptap/react';
import styled from 'styled-components';

export const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid rgba(173, 173, 173, 0.2);
  border-radius: 8px;
  background: rgba(173, 173, 173, 0.08);
  overflow: hidden;

  &:focus-within {
    outline: 1px solid var(--color-data-company-background-hover, #4a90e2);
    border-color: var(--color-data-company-background-hover, #4a90e2);
  }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
  background: rgba(173, 173, 173, 0.04);
`;

export const ToolbarButton = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 4px 8px;
  border: 1px solid rgba(173, 173, 173, 0.2);
  border-radius: 4px;
  background: ${({ active }) => (active ? 'rgba(74, 144, 226, 0.2)' : 'transparent')};
  color: ${({ active }) =>
    active ? 'var(--color-data-company-background-hover, #4a90e2)' : 'var(--color-text, #1c1b1f)'};
  cursor: pointer;
  font-size: 14px;
  font-weight: ${({ active }) => (active ? '600' : '400')};
  transition: all 0.2s ease;

  &:hover {
    background: ${({ active }) =>
      active ? 'rgba(74, 144, 226, 0.3)' : 'rgba(173, 173, 173, 0.1)'};
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: 2px solid var(--color-data-company-background-hover, #4a90e2);
    outline-offset: 2px;
  }

  strong {
    font-weight: 700;
  }

  u {
    text-decoration: underline;
  }
`;

export const EditorWrapper = styled(EditorContent)`
  min-height: 102px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 8px;
  padding: 8px;
  border: none;
  outline: none;
  resize: none;
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  color: var(--color-text, #1c1b1f);

  & > [role='textbox'] {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    resize: none;
  }

  .ProseMirror {
    width: 100%;
    min-height: 86px;
    outline: none;

    p {
      margin: 0;
      padding: 0;
    }

    p.is-empty::before {
      content: attr(data-placeholder);
      color: #999;
      float: left;
      height: 0;
      pointer-events: none;
    }

    .rich-text-link {
      color: var(--color-data-company-background-hover, #4a90e2);
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    u {
      text-decoration: underline;
    }

    strong {
      font-weight: 700;
    }
  }
`;

export const LinkDialog = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  padding: 12px;
  background: white;
  border: 1px solid rgba(173, 173, 173, 0.2);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 300px;
`;

export const LinkInput = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid rgba(173, 173, 173, 0.2);
  border-radius: 4px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: var(--color-data-company-background-hover, #4a90e2);
    outline: 1px solid var(--color-data-company-background-hover, #4a90e2);
  }
`;

export const LinkButton = styled.button<{ primary?: boolean }>`
  padding: 6px 12px;
  border: 1px solid rgba(173, 173, 173, 0.2);
  border-radius: 4px;
  background: ${({ primary }) =>
    primary ? 'var(--color-data-company-background-hover, #4a90e2)' : 'transparent'};
  color: ${({ primary }) => (primary ? 'white' : 'var(--color-text, #1c1b1f)')};
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ primary }) =>
      primary ? 'rgba(74, 144, 226, 0.9)' : 'rgba(173, 173, 173, 0.1)'};
  }

  &:focus {
    outline: 2px solid var(--color-data-company-background-hover, #4a90e2);
    outline-offset: 2px;
  }
`;
